'use strict';

/**
 * @abstract
 */
bbw.model.AbstractPostManager = bbw.model.BasePostManager.extend({

    /**
     * @type {bbw.model.Post}
     */
    _post: undefined,
    _postId: undefined,

    commentPerPage: 10,

    getUserId: function() {
        if (!this._post) {
            return undefined;
        }
        if (this._post.get('as_admin')) {
            return undefined;
        }
        return this._post.get('user_id');
    },

    setPostId: function(postId) {
        this._postId = postId;
        return this;
    },

    _getPostTypeName: function() {
        Class.abstractMethod();
    },

    _init: function() {
        this._post = this._modelFactory.create(bbw.model.Post);
    },

    _wireEntityScope: function(scope, path) {
        this._post.wireScope(scope[path], 'post');
    },

    _getPageChangeWatchExpr: function() {
        return 'post.comments.items.length';
    },

    _getPerPage: function() {
        return this.perPage || this.commentPerPage;
    },

    hasMore: function() {
        var comments = this._getCommentsCollectionIfLoaded();
        return comments ? comments.getMoreCount() > 0 : false;
    },

    canMore: function() {
        return this._canMoreFn ? (this._canMoreFn)() : true;
    },

    setCanMoreFn: function(fn) {
        this._canMoreFn = angular.isFunction(fn) ? fn : undefined;
        return this;
    },

    isLoading: function() {
        var comments = this._getCommentsCollectionIfLoaded();
        return comments ? comments.isLoading() : true;
    },

    updateComment: function(comment, isNew) {
        this._updateComment(this._post, comment);
        if (isNew) {
            var comments = this._getCommentsCollectionIfLoaded();
            if (comments) {
                comments.incrementCount();
            }
        }
    },

    loadMore: function() {
        return this.getCommentCollection().then(function(comments) {
            comments.loadMore();
        });
    },

    getScopePost: function() {
        return this._post;
    },

    _doInit: function() {
        return this._doLoadPost();
    },

    _doLoadPost: function() {
        return this._post.load(this._getPostTypeName(), this._postId).then(this.getCommentCollection.bind(this));
    }

});
